import { Typography, styled } from '@mui/material';

export const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.TETRIARY,
}));
